<template>
  <button class="cs-icon-button" :class="{ selected, disabled }" v-bind="$attrs" v-on="$listeners">
    <cs-icon :icon="icon"></cs-icon>
  </button>
</template>

<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'

@Component
export default class CsIconButton extends BaseComponent {
  @Prop({ type: String })
  icon!: string

  @Prop({ type: Boolean })
  selected!: boolean

  @Prop({ type: Boolean, default: false })
  disabled!: boolean
}
</script>

<style lang="less">
.cs-icon-button {
  width: 40px;
  height: 40px;
  font-size: 18px;
  color: #0a1629;
  text-align: center;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 6px 58px rgba(121, 145, 173, 0.2);

  > * {
    line-height: 40px;
  }

  &:hover {
    color: #0a1629;
    background: #e6edf5;
  }

  &.selected {
    color: #2981f8;
  }

  &.disabled {
    cursor: not-allowed;
    background: #e6edf5;
    opacity: 0.49;
  }
}
</style>
